import React from 'react';

const achievements = [
    {
        id: 1,
        title: 'Innovative Achievement in Education Technology',
        description: 'Mela Software proudly won $2,000 in a prestigious entrepreneurship competition for our innovative remote learning platform. We developed an Android application that enables students to access educational resources offline, fostering seamless connections between students and teachers.',
        image: 'assets/award1.jpg'
    }
];

const Achievement = () => {
    return (
        <section id="achievements" className="px-5 lg:px-10 py-10 w-full my-20 max-w-5xl mx-auto bg-orange-100">
            <h2 className="text-4xl font-bold text-center text-orange-400 mb-8">Our Achievements</h2>
            <ul className="space-y-6">
                {achievements.map((achievement) => (
                    <li 
                        key={achievement.id} 
                        className="achievement-item bg-orange-100 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
                    >
                        <img 
                            src={achievement.image} 
                            alt={achievement.title} 
                            className="w-full h-60 object-cover rounded-lg mb-4 mx-auto" 
                        /> 
                        <h3 className="text-2xl font-semibold text-orange-500 text-center mb-2">{achievement.title}</h3>
                        <p className="text-gray-700 text-center">{achievement.description}</p>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default Achievement;